import { keyMirror } from '../utils';

export default keyMirror([
    'PROMISE_UPDATE_CACHE',
]);
